// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2Nzgl","header":"Card_header__3oZUs","headerText":"Card_headerText__25FKS"};